import React from 'react'
import { WemoloTypography } from '../../../components/Wemolo'
import type { EditPayload } from '../changelog'
import styles from './EditDetails.module.css'
import { humanizeField } from '../utils'

interface EditDetailsProps {
    payload: EditPayload
    hiddenCount?: number
    onToggleExpand?: () => void
}

export const EditDetails = ({ payload, hiddenCount = 0, onToggleExpand }: EditDetailsProps) => {
    return (
        <div className={styles.container}>
            {payload.changes.map((change, i) => (
                <div key={i} className={styles.row}>
                    <span className={styles.dot} />
                    <WemoloTypography variant="label-xsmall" tag="span" className={styles.fieldName}>
                        <span title={change.field}>{humanizeField(change.field)}</span>
                    </WemoloTypography>
                    <WemoloTypography variant="label-xsmall" tag="span" className={styles.separator}>
                        ·
                    </WemoloTypography>
                    <WemoloTypography variant="label-xsmall" tag="span" className={styles.value}>
                        {change.before || '—'}
                    </WemoloTypography>
                    <WemoloTypography variant="label-xsmall" tag="span" className={styles.arrow}>
                        →
                    </WemoloTypography>
                    <WemoloTypography variant="label-xsmall" tag="span" className={styles.value}>
                        {change.after || '—'}
                    </WemoloTypography>
                </div>
            ))}
            {onToggleExpand && (
                <button className={styles.toggle} onClick={onToggleExpand}>
                    <WemoloTypography variant="label-xsmall" tag="span">
                        {hiddenCount > 0 ? `See ${hiddenCount} more` : 'See less'}
                    </WemoloTypography>
                </button>
            )}
        </div>
    )
}
